__turbopack_context__.v({
  "brand": "product-two-module-scss-module__NYko8a__brand",
  "card": "product-two-module-scss-module__NYko8a__card",
  "catBadge": "product-two-module-scss-module__NYko8a__catBadge",
  "catMore": "product-two-module-scss-module__NYko8a__catMore",
  "coin": "product-two-module-scss-module__NYko8a__coin",
  "from": "product-two-module-scss-module__NYko8a__from",
  "imgWrap": "product-two-module-scss-module__NYko8a__imgWrap",
  "info": "product-two-module-scss-module__NYko8a__info",
  "media": "product-two-module-scss-module__NYko8a__media",
  "mediaLink": "product-two-module-scss-module__NYko8a__mediaLink",
  "model": "product-two-module-scss-module__NYko8a__model",
  "name": "product-two-module-scss-module__NYko8a__name",
  "overlay": "product-two-module-scss-module__NYko8a__overlay",
  "pointsPill": "product-two-module-scss-module__NYko8a__pointsPill",
  "quickview": "product-two-module-scss-module__NYko8a__quickview",
  "topLeft": "product-two-module-scss-module__NYko8a__topLeft",
});
